import { GetterTree } from 'vuex'

import { OfferCartsState } from './types'
import { RootState } from '../types'
import { Seller, Offer, OfferItem } from '@/types'

export const getters: GetterTree<OfferCartsState, RootState> = {
  getOffers(state): Offer[] | null {
    return state.offers
  },
  getActiveOffer(state): Offer | null {
    return state.activeOffer
  },
  getAddOfferItemRequired(state): OfferItem | null {
    return state.addOfferItemRequired
  },
  getAddedOfferItem(state): boolean {
    return state.addedOfferItem
  },
  getUploadInventoryListRequired(state): File | null {
    return state.uploadInventoryListRequired
  },
  getRequestUploadInventoryList(state): boolean {
    return state.requestUploadInventoryList
  },
}
